import React, { FC } from 'react'

import { IconBriefcaseProps } from './IconBriefcase.types'
import * as Styled from './styles/IconBriefcase.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBriefcase: FC<IconBriefcaseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBriefcaseProps['size'],
  isResponsive = false,
}: IconBriefcaseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#1577b14e-0363-4b94-b423-9482f45c0967__a)' strokeWidth='2'>
          <path d='M21 6.933h6a4 4 0 0 1 4 4v2H17v-2a4 4 0 0 1 4-4v0Z' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' />
          <path d='M9 12.932h34V37a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V16.933a4 4 0 0 1 4-4Z' stroke='#0D0D0D' strokeMiterlimit='10' />
          <path d='m5 20.688 17.575 6.702a4 4 0 0 0 2.85 0L43 20.687' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <defs>
          <clipPath id='1577b14e-0363-4b94-b423-9482f45c0967__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBriefcase
